import { func, number, string } from 'prop-types';
import { useState, useEffect } from 'react';
import { IonIcon } from '@ionic/react';
import { stopwatch } from 'ionicons/icons';
import { t } from 'i18next';
import cn from 'classnames';

import { TIMER_ENDED, TIMER_SECOND, currentTimestamp, getDateValue, getTimeToFinish } from '~utils/time';

import styles from './styles.module.scss';

const Timer = ({ endDatetime, interval = TIMER_SECOND, setProductTimeEnded, className }) => {
  const [timespan, setTimespan] = useState(getDateValue(endDatetime) - currentTimestamp().valueOf());
  const [timerEnded, setTimerEnded] = useState(timespan < 0);

  const finishTime = timeId => {
    const timeToFinish = getDateValue(endDatetime) - currentTimestamp().valueOf();
    if (timeToFinish < 0) {
      clearInterval(timeId);
      setProductTimeEnded && setProductTimeEnded();
      setTimerEnded(true);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      finishTime(intervalId);
      setTimespan(_timespan => _timespan - interval);
    }, interval);

    return () => {
      clearInterval(intervalId);
    };
  }, [interval]);

  return (
    <div className={cn(styles.container, className)}>
      <IonIcon className={styles.icon} icon={stopwatch} />
      <span className={styles.text}>
        {t('Timer:endsIn', {
          time: timerEnded ? TIMER_ENDED : getTimeToFinish(timespan)
        })}
      </span>
    </div>
  );
};

Timer.propTypes = {
  className: string,
  endDatetime: string,
  interval: number,
  setProductTimeEnded: func
};

export default Timer;
